"use client";

import { CircleHelp } from "lucide-react";

import {
  NAV_FOCUS_RING,
  NAV_ICON_BUTTON,
  NAV_INK_ICON_BUTTON,
  NAV_INK_OPEN,
} from "@/components/nav/nav-styles";
import { cn } from "@/lib/utils";

/**
 * The Help sheet's opener (`components/support/SupportSheet.jsx`): labelled
 * "Help" at the right end of the navy top bar, and the icon alone (`compact`)
 * in the cream phone header beside its other icon buttons. Pressing it again
 * closes the sheet.
 *
 * @param {{ open: boolean, onClick: () => void, compact?: boolean,
 *   className?: string }} props
 */
export default function HelpButton({
  open,
  onClick,
  compact = false,
  className,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-expanded={open}
      aria-haspopup="dialog"
      aria-label={compact ? "Help" : undefined}
      className={cn(
        compact
          ? cn(NAV_ICON_BUTTON, NAV_FOCUS_RING)
          : cn(NAV_INK_ICON_BUTTON, "w-auto gap-2 px-3 text-sm font-medium"),
        open && !compact && NAV_INK_OPEN,
        className,
      )}
    >
      <CircleHelp className={compact ? "h-5 w-5" : "h-4 w-4"} aria-hidden />
      {!compact && "Help"}
    </button>
  );
}
